<template>
  <div>
    <q-radio
      v-for="key in UserAttributeCode.default"
      :key="key"
      v-model="attribute"
      :label="UserAttributeCode.getName(key)"
      :val="key"
      color="primary"
      style="margin-right: 10px"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import * as UserAttributeCode from '../../common/code/UserAttributeCode';

interface Props {
  // ラジオボタンの値
  value?: string;
}

// 初期値
const props = withDefaults(defineProps<Props>(), {
  value: UserAttributeCode.default.REAGENT,
});
const emit = defineEmits(['selectValue']);

// 入力値
const attribute = computed({
  get: () => props.value,
  set: (value) => {
    emit('selectValue', value);
  },
});
</script>
